import { useNotify, useRecordContext, useRefresh, useResourceContext, useDelete } from 'react-admin';
import CraftDeleteButtonWithConfirmation from 'src/components/CraftDeleteButtonWithConfirmation';

const DeleteButton = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext<{ id: string; user_id: string | number; program_id: string | number }>();
  const resource = useResourceContext();

  const [doDelete, { isLoading }] = useDelete();

  const handleDelete = async () => {
    if (!record) return;
    try {
      await doDelete(resource, { id: record.id });
      notify('User removed from program', { type: 'success' });
      refresh();
    } catch (e) {
      notify('There was a problem deleting the item. Please try again.', { type: 'error' });
    }
  };

  return (
    <CraftDeleteButtonWithConfirmation
      onDelete={handleDelete}
      loading={isLoading}
      title={`Remove user ${record?.user_id} from program`}
      content="Are you sure you want to remove this user from the program?"
    />
  );
};

export default DeleteButton;
